import * as Sentry from '@sentry/react';

import UnexpectedErrorPage from '@src/pages/500';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <Sentry.ErrorBoundary fallback={<UnexpectedErrorPage />}>{children}</Sentry.ErrorBoundary>
);
